import React, { useState } from "react";

// Stylised SVG dot-map of Australia (not geographically perfect — designed)
const states = [
  { code: "SA", name: "South Australia", x: 405, y: 280, projects: 86, cities: ["Adelaide", "Port Adelaide"] },
  { code: "VIC", name: "Victoria", x: 540, y: 360, projects: 64, cities: ["Melbourne", "Geelong", "Aireys Inlet"] },
  { code: "NSW", name: "New South Wales", x: 600, y: 290, projects: 48, cities: ["Sydney"] },
  { code: "QLD", name: "Queensland", x: 570, y: 180, projects: 22, cities: ["Brisbane"] },
  { code: "WA", name: "Western Australia", x: 180, y: 250, projects: 16, cities: ["Perth"] },
  { code: "TAS", name: "Tasmania", x: 560, y: 440, projects: 4, cities: ["Hobart"] },
];

export default function MapAU() {
  const [active, setActive] = useState("SA");
  const cur = states.find((s) => s.code === active);

  return (
    <section data-testid="section-map" className="bg-ink text-bone py-24 md:py-40 relative overflow-hidden">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-12 gap-8 relative">
        <p className="label col-span-12 md:col-span-2 text-bone/50">04 — Where we work</p>
        <h2 className="display col-span-12 md:col-span-9 text-[9vw] md:text-6xl lg:text-[5rem] leading-[0.98] tracking-tighter text-bone">
          Six states. <span className="italic text-clay font-light">One coastline of work.</span>
        </h2>

        <div className="col-span-12 lg:col-span-8 mt-12 reveal">
          <div className="relative w-full aspect-[16/11] bg-ink border border-bone/10">
            <svg viewBox="0 0 800 550" className="w-full h-full">
              {/* outline of australia — simplified silhouette */}
              <path
                d="M120 240 C 120 180, 200 130, 290 130 C 360 105, 460 110, 540 130 C 620 130, 700 175, 720 250 C 720 320, 680 360, 640 370 C 620 395, 600 410, 560 420 C 530 440, 480 440, 440 425 C 400 440, 350 435, 310 420 C 260 415, 220 400, 180 380 C 140 350, 110 310, 120 240 Z"
                fill="none"
                stroke="#F5F4F0"
                strokeWidth="1"
                opacity="0.35"
              />
              {/* tasmania */}
              <path d="M530 470 C 540 460, 580 460, 590 470 C 600 485, 590 500, 570 500 C 550 502, 530 490, 530 470 Z" fill="none" stroke="#F5F4F0" strokeWidth="1" opacity="0.35" />

              {/* state dots */}
              {states.map((s) => {
                const isActive = s.code === active;
                return (
                  <g
                    key={s.code}
                    style={{ cursor: "pointer" }}
                    data-testid={`map-state-${s.code}`}
                    onMouseEnter={() => setActive(s.code)}
                    onClick={() => setActive(s.code)}
                  >
                    {isActive && <circle cx={s.x} cy={s.y} r="28" fill="#9E3B22" opacity="0.18" />}
                    <circle cx={s.x} cy={s.y} r={isActive ? 9 : 5} fill={isActive ? "#9E3B22" : "#F5F4F0"} className="transition-all" />
                    <text x={s.x + 14} y={s.y + 5} fill="#F5F4F0" fontSize="13" opacity={isActive ? 1 : 0.6} className="font-mono">
                      {s.code}
                    </text>
                  </g>
                );
              })}
            </svg>
            <p className="absolute bottom-4 right-5 label text-bone/40 font-mono">Studio: Adelaide — 34.87°S 138.62°E</p>
          </div>
        </div>

        <aside className="col-span-12 lg:col-span-4 mt-12 reveal">
          <p className="label text-bone/40">Selected state</p>
          <h3 className="display text-5xl md:text-6xl mt-4 text-bone">{cur.name}</h3>
          <div className="mt-8 flex items-baseline gap-6">
            <div>
              <p className="display text-7xl text-clay leading-none">{cur.projects}</p>
              <p className="label text-bone/50 mt-2">Projects delivered</p>
            </div>
          </div>
          <div className="mt-10">
            <p className="label text-bone/40 mb-3">Cities & towns</p>
            <ul className="space-y-2">
              {cur.cities.map((c) => (
                <li key={c} className="text-lg flex items-center gap-3 text-bone/90">
                  <span className="w-6 h-px bg-clay" /> {c}
                </li>
              ))}
            </ul>
          </div>
          <p className="mt-10 text-sm text-bone/60 leading-relaxed">
            Hover or tap a state to explore where Virarc has worked. We document and deliver from our Adelaide studio — and travel where the build is.
          </p>
        </aside>
      </div>
    </section>
  );
}
